import $ from 'jquery'
import {ReportGroupingLevel} from '../../../constants'
import CSVPreviewSection from '../CSVPreviewSection'

export default function LeaveCSVPreviewHeader(){}

LeaveCSVPreviewHeader.prototype = new CSVPreviewSection();

LeaveCSVPreviewHeader.prototype.init = function( firstGroupingLevel, secondGroupingLevel, columnsStrategy, numOfGroupingRows, columnsConfig ){
    CSVPreviewSection.prototype.init.call( this );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingRows = numOfGroupingRows;
    this.columnsConfig = columnsConfig;
    return this;
};

LeaveCSVPreviewHeader.prototype.addRows = function( tBody )
{
    let mainHeaderRow = this.createRow()
    $(mainHeaderRow ).addClass("headerGroupingRow");
    ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel))
    if (this.secondGroupingLevel !== ReportGroupingLevel.NONE) {
        ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel))
    }

    this.columnsStrategy.addMainHeaderRowCells( mainHeaderRow );
    this.addRow( tBody, mainHeaderRow );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/leave/LeaveCSVPreviewHeader.js